<template>
  <transition v-if="open" name="modal">
    <div class="modal__wrapper" @click="clickOnWrapper">
      <div class="modal-content" :style="`max-width: ${width}`" @click.stop>
        <div class="modal-header">
          <bimTextMain bold class="modal-title" v-if="title"> {{ title }} </bimTextMain>
          <!-- @slot Слот с хедером. Рассчитан на кастомизированный заголовок. Не рекомендуется
          использовать одновременно с пропсом title
           -->
          <slot name="header" />
          <div
            v-if="!hideCloseButton"
            class="button-close"
            @click="$emit('input', false)"
            v-html="require('@/assets/img/icon-close.svg')"
          ></div>
        </div>
        <div class="modal-body">
          <!-- @slot Слот с контентом модального окна -->
          <slot></slot>
        </div>
        <div v-if="$scopedSlots.footer" class="modal-footer">
          <!-- @slot Слот с футером. Рассчитан на кнопки закрытия или небольшого контента размером
           по высоте не более 56px
           -->
          <slot name="footer" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import bimTextMain from '@/components/text/bimTextMain/bimTextMain.vue'

export default {
  components: {
    bimTextMain,
  },
  props: {
    /**
     * Текст заголовка модального окна
     */
    title: {
      type: String,
    },
    /**
     * Состояние окна (закрыто или открыто)
     * @model
     */
    value: Boolean,
    /**
     * Максимальная ширина окна
     */
    width: {
      type: String,
      default: '420px'
    },
    /**
     * Закрыть при клике на wrapper
     */
    closeOnWrapper: {
      type: Boolean,
      default: false,
    },
    /**
     * Скрыть кнопку закрытия
     */
    hideCloseButton: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      open: null,
      mouseDownPopup: false,
    }
  },
  watch: {
    value (val) {
      this.open = val

      if (val) {
        this.setCloseListener()
      } else {
        this.removeCloseListener()
      }
    },
  },
  mounted () {
    this.open = this.value
  },
  methods: {
    setCloseListener () {
      document.body.addEventListener('keyup', this.keyupListener)
    },
    removeCloseListener () {
      document.body.removeEventListener('keyup', this.keyupListener)
    },
    keyupListener (event) {
      if (event.keyCode === 27) {
        /**
         * Отправляет состояние модального окна (открыто или закрыто)
         * @param {boolean}
         */
        this.$emit('input', false)
      }
    },
    clickOnWrapper () {
      if (this.closeOnWrapper) {
        this.$emit('input', false)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
// Animation
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-content,
.modal-leave-active .modal-content {
  transform: scale(1.1);
}

.modal__wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1010;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: rgba(0, 0, 0, 0.25);

  transition: opacity 0.2s ease;
}

.modal-content {
  position: relative;
  z-index: 999;

  max-height: 90vh;
  padding: 24px 0;
  overflow: hidden;

  background-color: $white-color;
  border-radius: 4px;

  transition: all 0.2s ease;
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-self: center;
  padding: 0 24px;
  padding-right: 55px;
  padding-bottom: 14px;
  .button-close {
    cursor: pointer;
  }
}
.modal-body {
  max-height: calc(90vh - 114px);
  padding: 0 24px;
  overflow-y: auto;

  line-height: 1.5;
  &::-webkit-scrollbar-track {
    background-color: $white-color-100;
    border-radius: 4px;
  }
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: $white-color-600;
    border-radius: 4px;
  }
  &:hover::-webkit-scrollbar-thumb {
    background-color: $white-color-700;
  }
}

.modal-footer {
  padding: 14px 24px 0;
}

.button-close {
  position: absolute;
  top: 24px;
  right: 24px;
  &:hover {
    opacity: 0.65;
  }
}

.button-close /deep/ svg {
  width: 16px !important;
}
</style>
